/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Public_FooterInputs */

const vi_grower_area_public_footer = /** @type {(inputs: Grower_Area_Public_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông tin vùng trồng chè — HTX Chè Hảo Đạt`)
};

/**

* @param {Grower_Area_Public_FooterInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_public_footer = /** @type {((inputs?: Grower_Area_Public_FooterInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Public_FooterInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_public_footer(inputs)
});